import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Center,
  Flex,
  Heading,
  Spinner,
  useToast,
  VStack
} from '@chakra-ui/react'
import { Form } from './Form'
import useSeasonChallenges from './hooks/useSeasonChallenges'
import { AdminSeasonChallenge } from '@olagg/db-types'
import { SeasonChallengeFormData } from '@olagg/validation-schemas/seasonChallenge.schema'

const Edit = () => {
  const { id: seasonId, challenge_id } = useParams<{ id: string; challenge_id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getChallenge, updateChallenge, loading } = useSeasonChallenges()

  const [challenge, setChallenge] = useState<AdminSeasonChallenge | null>(null)
  const [loadingChallenge, setLoadingChallenge] = useState(true)

  useEffect(() => {
    const loadChallenge = async () => {
      if (!challenge_id) return
      try {
        setLoadingChallenge(true)
        const challengeData = await getChallenge(challenge_id)
        setChallenge(challengeData.gameSeasonChallenge)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar el desafío',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate(`/seasons/${seasonId}/challenges`)
      } finally {
        setLoadingChallenge(false)
      }
    }

    loadChallenge()
  }, [challenge_id])

  const onSubmit = async (data: SeasonChallengeFormData) => {
    if (!challenge || !seasonId) return

    try {
      await updateChallenge(challenge.id.toString(), data)
      toast({
        title: 'Desafío actualizado',
        description: 'El desafío ha sido actualizado exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(`/seasons/${seasonId}/challenges`)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar el desafío',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate(`/seasons/${seasonId}/challenges`)
  }

  if (loadingChallenge) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!challenge || !seasonId) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Desafío no encontrado
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar Desafío</Heading>
        <Form
        initialData={challenge}
        seasonId={seasonId}
        onSubmit={onSubmit}
        onCancel={onCancel}
        loading={loading}
        isEdit={true}
      />
      </VStack>
    </Center>
  )
}

export default Edit
